import { z } from 'zod'

/**
 * The email-change link's query state.
 *
 * In its own module, not beside the screen: the router imports this eagerly to
 * validate the URL, and importing it from the screen file would drag that whole
 * lazy chunk into the main bundle — which is the one thing every route in this
 * tree is code-split to avoid.
 *
 * `.catch(undefined)` rather than a hard failure: a link mangled by a mail
 * client should reach a sentence explaining what to do, not a route error.
 */
export const confirmEmailSearchSchema = z.object({
  token: z.string().min(1).optional().catch(undefined),
})

/**
 * The password-reset link's query state. Same shape, same `.catch` reasoning —
 * a separate export rather than a shared one so the two routes cannot silently
 * start validating each other's links.
 */
export const resetPasswordSearchSchema = z.object({
  token: z.string().min(1).optional().catch(undefined),
})

/**
 * The seat-invitation link's query state.
 *
 * A third export of the same shape rather than a shared one, for the reason
 * the second gives: two routes that validated each other's links could start
 * accepting a token meant for the other flow without anything failing.
 */
export const seatInvitationSearchSchema = z.object({
  token: z.string().min(1).optional().catch(undefined),
})

/** « Conserver mon compte » — the token from the deletion mail (19 Oct 2026). */
export const keepAccountSearchSchema = z.object({
  token: z.string().min(1).optional().catch(undefined),
})
